// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const API_MAIN_URL = 'https://www.expediusa.com/';
const API_BASE_URL = API_MAIN_URL + 'api/';

const FRONT_URL = 'https://www.expediusa.com';
//const FRONT_URL = 'http://localhost:9003/';
const ADMIN_URL = 'https://www.expediusa.com/admin';

export const environment = {
  production: false,

  /**varibales which are using by core files (pipes,_services,core,directive,guards)*/
  OTOK_API_KEY: '47606371',
  API_URL: API_BASE_URL,
  REFRESH_TOKEN_URL: API_BASE_URL + 'regenerate_jwt',
  SITE_URL: FRONT_URL + '/',
  SITE_URL_WITHOUT_SLASH: FRONT_URL,
  NODE_URL: ADMIN_URL,
  SITE_IMAGE_URL: '/assets/images/',
  IMAGE_BASE_URL: API_MAIN_URL + 'public/frontend/uploads/user/',
  SAMPLE_CSV_BASE_URL: API_MAIN_URL + 'public/frontend/uploads/',
  RESUME_DOWNLOAD_URL: API_MAIN_URL + 'crons/download_resume/',
  SITE_TITLE: 'Expediusa',
  SITE_DESCRIPTION: 'Expediusa',
  SITE_KEYWORDS: 'Expediusa',
  ENCRIPT_API: 0,
  ENCRIPTION_KEY: '123456$#@$^@1ERF123456$#@$^@1ERF',
  stripePublicKey:"77777777777777777777",
  ENCRIPTION_IV: '123456$#@$^@1ERF',
  RECAPTCHA_SITE_KEY: '6LdXr3IcAAAAADk5MUOkGCLEVsGB2tS1o93pQYn-',
  GOOGLE_MAP_SITE_KEY: 'AIzaSyA81gjjpQGwZNSDDbiw5i56zMr8ITIz0tc',
  PAYPAL_SITE_KEY:
    'AUXlc0hscBe5pm8KYAP4mUcInhF8I4S6jlmIMYJIGoTBDQr982G9gZs-lGa42cGlyM6D9Bpx1E2cXer2',
  SUCCESS_STATUS: 'success',
  ERROR_STATUS: 'error',
  DISPLAY_DATE_FORMATE: 'MM-dd-yyyy',
  CURRENCY_CODE: 'USD',
  PASWORD_MIN_LENGTH: 8,
  PASWORD_MAX_LENGTH: 100,
  MAX_FILE_UPLOAD_LIMIT: 5,
  POST_PER_PAGE: 10,
  DEACTIVE: 0,
  CKEDITIOR_OPTIONS: {
    toolbar: [
        ['Bold', 'Italic', 'Strike'],
        ['NumberedList', 'BulletedList'], // Lists
        ['Outdent', 'Indent'], // Paragraph options
        ['Format'] // Heading options
    ],
    format_tags: 'p;h1;h2;h3;pre',
    fontSize_sizes: '10/10px;12/12px;14/14px;15/15px;16/16px;18/18px;20/20px;24/24px;36/36px', // Define font sizes
    contentsCss: `
    body { 
        font-size: 15px !important; 
        font-family: "AvenirNextLTPro-Medium", sans-serif !important; 
        font-weight: 500 !important; /* Slightly bolder text */
        line-height: 1.6 !important;  /* Increases space between lines */
        letter-spacing: 0.7px !important; /* Adjusts spacing between letters */
        padding: 10px !important; /* Adds padding inside the editor */
         color: #111428 !important; /* Text color */
    }
`  // Available heading options
  },
  /**varibales which are using by core files (pipes,_services,core,directive,guards)*/

  /**varibales which are using in modules */

  /**global variable in all modules*/
  TOOLTIP_OPTIONS: { placement: 'left', 'show-delay': 500 },
  TOTAL_PAGE_TO_SHOW: 10, //pagination variable
  CURRENCY_SYMBOL: '$',
  /**global variable in all modules*/

  /**header variable */
  DEFAULT_LANGUAGE: 'en',
  LANGUAGES_ARRAY: ['en', 'ar'],
  REVIEW_STARS: ['5', '4', '3', '2', '1'],
  LANGUAGES_DIRECTIONS: { en: 'ltr', ar: 'rtl' },
  /**header variable */

  /**blod module variables*/
  FACEBOOK_SHARE_URL: 'https://www.facebook.com/sharer/sharer.php?u=',
  TWITTER_SHARE_URL: 'https://twitter.com/intent/tweet?url=',
  LINKEDIN_SHARE_URL:
    'https://www.linkedin.com/shareArticle?mini=true&amp;url=',
  BLOG_CATEGORY: 'blog_category',
  DEFAULT_SKIP: 0,
  BLOG_LIMIT: 2,
  BLOG_FEATURE_TITLE_LENGTH: 50,
  BLOG_TITLE_LENGTH: 35,
  /**blod module variables*/

  /**employer listing variables*/
  ABOUT_COMPANY_LENGTH: 300,
  /**employer listing variables*/

  /**dropdown related variable for employer and jobseeker */
  REQUIREED_EDUCATION: [{ id: '', text: 'Required Education' }],
  JOB_INDUSTRY: [{ id: '', text: 'Job Industry' }],
  JOB_LEVEL: [{ id: '', text: 'Job Level' }],
  AGE_GROUP: [{ id: '', text: 'Age Group' }],
  NATIONALITY: [{ id: '', text: 'Nationality' }],
  DEGREE: [{ id: '', text: 'Degree' }],
  /**dropdown related variable for employer and jobseeker */
  META_IMAGE: {
    job: 'https://www.expediusa.com/assets/images/joblisting.webp',
    employer: 'https://www.expediusa.com/assets/images/joblisting.webp',
    'about-us':
      'https://www.expediusa.com/public/frontend/uploads/cms/SEP2021/1631684303953-stroyimage.jpg',
    'featureing-amenity': '',
    'terms-condition':
      'https://www.expediusa.com/assets/images/terms-conditions-banner.webp',
    'privacy-policy':
      'https://www.expediusa.com/assets/images/contact-banner.webp',
    'trust-and-safety':
      'https://www.expediusa.com/assets/images/privacypolicy-banner.webp',
    'fraud-alert': '',
    'contact-us': 'https://www.expediusa.com/assets/images/contact-banner.webp',
    blog: 'https://www.expediusa.com/assets/images/bloglisting-banner.webp',
    category: 'https://www.expediusa.com/assets/images/joblisting.webp',
  },
   AWS_ACCESS_KEY_ID: "AKIAY53K45HBSBHU7MOZ",
  AWS_SECRET_ACCESS_KEY: "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",
  AWS_REGION: "us-east-1",
  RESUME_BUCKET_NAME:"prod-resumes-intake.expediusa.com",
 PROFILE_BUCKET_NAME:"prod-profiles-intake.expediusa.com",
 PROFILE_BASE_URL:"https://prod-profile-images.expediusa.com",
  //RESUME_BUCKET_NAME:"dev-resumes-intake.expediusa.com",
 //PROFILE_BUCKET_NAME:"dev-profiles-intake.expediusa.com",
 //PROFILE_BASE_URL:"https://dev-profile-images.expediusa.com",
  IDENTITY_POOL_ID: "us-east-1:51be6f91-3abb-4648-80b5-6a878d4b25c6",
    SIGNED_API:"https://pp4vjvldji.execute-api.us-east-1.amazonaws.com/dev",
  AWS_API_KEY:"pQ36IFIbU91Mm5kCjm6mN7YEvpulPdHDKlN4OGAf",
  adsense: {
    adClient: 'ca-pub-3057891234362980',
    show: true
 }
  /**varibales which are using in modules */
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
